(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["timer-addons"] && !Shopify.designMode) return;
  try {
    class TimerAddons extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('[data-timer-variants]')?.textContent || '[]');
      this.formDataHandler = this.handleFormData.bind(this);
      this.variantHandler = this.handleVariantUpdate.bind(this);
      this.details = this.closest('.product-details');
      this.section = this.closest('.shopify-section');
      this.section?.addEventListener('variant:update', this.variantHandler);
      this.bindToProductForm();
      this.observer = new MutationObserver(() => this.bindToProductForm());
      if (this.details) this.observer.observe(this.details, { childList: true, subtree: true });
    }

    disconnectedCallback() {
      this.productForm?.removeEventListener('formdata', this.formDataHandler);
      this.section?.removeEventListener('variant:update', this.variantHandler);
      this.observer?.disconnect();
    }

    bindToProductForm() {
      const nextForm = this.details?.querySelector('product-form-component form');
      if (!nextForm || nextForm === this.productForm) return;
      this.productForm?.removeEventListener('formdata', this.formDataHandler);
      this.productForm = nextForm;
      this.productForm.addEventListener('formdata', this.formDataHandler);
      this.updateIncludedBack(this.productForm.querySelector('[name="id"]')?.value);
    }

    handleVariantUpdate(event) {
      if (String(event.detail.data.productId) !== this.dataset.productId) return;
      this.updateIncludedBack(event.detail.resource?.id);
    }

    updateIncludedBack(variantId) {
      const variant = this.variants.find((item) => String(item.id) === String(variantId));
      const selectedBack = variant?.option1;
      const note = this.querySelector('[data-included-note]');
      if (note) {
        const messages = { 'Standard Flat Back': note.dataset.flat, 'Hat Clip': note.dataset.hat, 'MOLLE': note.dataset.molle };
        const text = messages[selectedBack] || note.dataset.choose;
        if (note.textContent !== text) note.textContent = text;
      }

      this.querySelectorAll('[data-back]').forEach((row) => {
        const input = row.querySelector('[data-timer-addon]');
        input.disabled = input.dataset.unavailable === 'true';
        if (input.disabled) input.checked = false;
      });
    }

    handleFormData(event) {
      const variantId = event.formData.get('id');
      if (!variantId) return;
      this.updateIncludedBack(variantId);
      const selected = [...this.querySelectorAll('[data-timer-addon]:checked:not(:disabled)')];
      if (selected.length === 0) return;

      const quantity = event.formData.get('quantity') || '1';
      event.formData.set('items[0][id]', variantId.toString());
      event.formData.set('items[0][quantity]', quantity.toString());

      for (const [key, value] of [...event.formData.entries()]) {
        if (key.startsWith('properties[') && key.endsWith(']')) {
          event.formData.set(key.replace(/^properties/, 'items[0][properties]'), value);
          event.formData.delete(key);
        }
      }
      const sellingPlan = event.formData.get('selling_plan');
      if (sellingPlan) {
        event.formData.set('items[0][selling_plan]', sellingPlan);
        event.formData.delete('selling_plan');
      }

      selected.forEach((input, index) => {
        event.formData.set('items[' + (index + 1) + '][id]', input.dataset.variantId);
        event.formData.set('items[' + (index + 1) + '][quantity]', '1');
      });
      event.formData.delete('id');
      event.formData.delete('quantity');
    }
  }

  if (!customElements.get('timer-addons')) {
    customElements.define('timer-addons', TimerAddons);
  }
  } catch(e) { console.error(e); }
})();

})();
